import * as React from 'react'
import { faMoon } from '@fortawesome/free-regular-svg-icons'
import { useShallow } from 'zustand/shallow'
import { FaIcon, faMoonSolid } from '@/lib/fa'
import Tooltip from '@/modules/drivers/shared/ToolTip'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import { useThemeModeStore } from '@/modules/shared/stores/themeModeStore'

/** Przełącznik jasny/ciemny w tym samym wyglądzie co w pasku bocznym aplikacji. */
export const ThemeModeToggle: React.FC = () => {
  const { t } = useLocalize()
  const { mode, toggle } = useThemeModeStore(
    useShallow((s) => ({ mode: s.mode, toggle: s.toggle })),
  )
  const dark = mode === 'dark'
  return (
    <Tooltip
      onClick={toggle}
      text={dark ? t('shared.sidebar.theme-light') : t('shared.sidebar.theme-dark')}
      className={`tw-flex tw-h-5 tw-w-5 tw-cursor-pointer tw-items-center tw-justify-center tw-rounded tw-p-2 tw-text-content-base tw-opacity-80 tw-transition-opacity hover:tw-opacity-100 ${dark ? 'tw-bg-primary' : 'tw-bg-base-100'}`}
    >
      <FaIcon
        icon={dark ? faMoonSolid : faMoon}
        className={`tw-h-4 tw-w-4 ${dark ? 'tw-text-white' : 'tw-text-content-base'}`}
      />
    </Tooltip>
  )
}
